export const services = {
    'meta': {
        'title': 'Usługi świadczone przez nasze centrum • Centrum COLLIGO',
        'description': 'Lista usług świadczonych przez Centrum Psychiatrii i Psychoterapii COLLIGO'
    },
    'url': {
        'address': '#cityIdUrl#/uslugi/',
        'title': 'Usługi świadczone przez nasze centrum • Centrum COLLIGO',
        'name': 'Usługi'
    },
    'opengraph': {
        'image': {
            'url': null,
            'width': 150,
            'height': 150,
            'alt': 'Psychiatra dziecięcy w Toruniu. Psychiatra w Toruniu. Psychoterapia w Toruniu. Psychologia w Toruniu. Gabinety w dogodnym miejscu Torunia.'
        }
    }
}